<ng-container *transloco="let t;">
  <div class="card mb-0">
    <div class="card-header px-for-sidebar px-0">
        <div class="d-flex align-items-center">
          <h4 class="card-title font-medium-1">{{heading}}</h4>
        </div>
        <div class="btn-group graph-month-dropdown">
          <div ngbDropdown>
            <button ngbDropdownToggle class="btn btn-flat-secondary" type="button"
                id="dropdownMenuButton" rippleEffect>
                {{filter}} {{ t('Month (general) - Months') }}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                <a ngbDropdownItem href="javascript:void(0)" (click)="applyMonthsFilter('6')">6 {{ t('Month (general) - Months') }}</a>
                <a ngbDropdownItem href="javascript:void(0)" (click)="applyMonthsFilter('12')">12 {{ t('Month (general) - Months') }}</a>
            </div>
          </div>
        </div>
    </div>
    <div class="card-body p-0">  

    @if(isUpcomingGrpahLoader){
        <app-skeleton [section]="skeletonName"></app-skeleton>
    }
    
    @if(!graphData.length && !isUpcomingGrpahLoader){
        <div class="d-flex justify-content-center align-items-center no-data-div mt-1">
            <p class="mb-0 text-muted">{{ t('Contract control graph view no data text - (Contract control graph view) - No upcoming events') }}</p>
        </div>
    }

    @if(!isUpcomingGrpahLoader && graphData.length){  
            <div id="chart">
                <apx-chart
                    [series]="incomingChart.series"
                    [chart]="incomingChart.chart"
                    [stroke]="incomingChart.stroke"
                    [dataLabels]="incomingChart.dataLabels"
                    [xaxis]="incomingChart.xaxis"
                    [colors]="incomingChart.colors"
                    [fill]="incomingChart.fill"
                    [yaxis]="incomingChart.yaxis"
                    [legend]="incomingChart.legend"
                    [tooltip]="incomingChart.tooltip"
                    [responsive]="incomingChart.responsive"
                    [plotOptions]="incomingChart.plotOptions"
                    (mousemove)="onChartHover($event,1)"
                    (mouseout)="onChartHover($event,0)"
                    (click)="onChartClick($event)"
                ></apx-chart>  
            </div> 
            
            <div id="custom-tooltip" appendTo="body" [ngStyle]="{
                    position: 'absolute',
                    top: '0px',
                    left: '0px',
                    'min-width': '200px',
                    width: 'auto',
                    'max-width': '300px',
                    display: showTooltip,
                    opacity: tooltipOpacity
                }"
                (mousemove)="onTooltipHover(1)"
                (mouseout)="onTooltipHover(0)"       
            >

                <div class="custom-tooltip tooltip-hover" *ngIf="tooltipData && tooltipData.hasOwnProperty('type') && tooltipData.type === 'periodrenewal'">
                    <span class="tooltip-title mb-25">{{tooltipData.allData.activity}}</span>
                    <ul>
                        <li class="mb-0 mt-25 border-top hover-effect pt-50" (click)="navigateToContractControl(tooltipData.allData.id)"><span class="tooltip-link">{{tooltipData.allData.contract_name}}: {{tooltipData.allData.expiration_date | dateFormat | async}}</span></li>
                    </ul>
                </div>
                <div class="custom-tooltip tooltip-hover" *ngIf="tooltipData && tooltipData.hasOwnProperty('type') && tooltipData.type === 'all_types'">
                    <span class="tooltip-title mb-25">{{tooltipTitle}}</span>
                    <ul>
                        <li class="mb-0 mt-50 border-top hover-effect pt-50" *ngFor="let tooltipRow of tooltipData?.allData" (click)="navigateToContractControl(tooltipRow.id)"><span class="tooltip-link">{{tooltipRow.contract_name}}: {{tooltipRow.expiration_date | dateFormat | async}}</span></li>
                    </ul>
                </div>
                <div class="custom-tooltip tooltip-hover" *ngIf="!tooltipData || (tooltipData && !tooltipData.hasOwnProperty('type')) || (tooltipData && tooltipData.type !== 'periodrenewal' && tooltipData.type !== 'all_types')">
                    <span  class="tooltip-title mb-25">{{tooltipTitle}}</span>
                    <ul>
                        <li class="mb-0 mt-25 border-top hover-effect pt-50" *ngFor="let tooltipRow of tooltipData?.allData" (click)="navigateToContractControl(tooltipRow.id)"> <span class="tooltip-link">{{tooltipRow.todo_name}}: {{tooltipRow.expiration_date | dateFormat | async}}</span></li>
                    </ul>
                </div>
              </div>

            <!-- listing here -->
            <div *ngIf="skeletonName === 'contract_control_events_chart' && selectedBarListing.length > 0">
            <!-- Striped rows -->
                <div class="row" id="table-striped">
                  <div class="col-12">
                    <div class="card">
                      <div class="table-responsive">
                        <table class="table table-striped">
                          <thead>
                            <tr>
                              <th>{{ t('Contract column name selected chart bar listing - (Contract control listing section - graph view) - Contract') }}</th>
                              <th>{{ t('Category column name selected chart bar listing - (Contract control listing section - graph view) - Category') }}</th>
                              <th>{{ t('Organization column name selected chart bar listing - (Contract control listing section - graph view) - Organization') }}</th>
                              <th>{{ t('Contract no column name selected chart bar listing - (Contract control listing section - graph view) - Contract no') }}</th>
                              <th>{{ t('Status column name selected chart bar listing - (Contract control listing section - graph view) - Status') }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let data of selectedBarListing">
                            <tr>
                              <td>
                                <div>
                                    <a href="javascript:void(0);" class="fw-bold d-block text-nowrap text-primary mb-0" (click)="navigateToContractControl(data.id)">
                                        {{ data.contract_control_name }}
                                    </a>
                                    <small> {{ data?.document_type?.document_type }}</small>
                                </div>
                              </td>
                              <td>{{ data.category?.category_name ?? '' }}</td>
                              <td>{{ data.organization?.name ?? '' }}</td>
                              <td>{{ data.contract_no }}</td>
                              <td>
                                <div class="badge" [ngClass]="{'badge-light-success': data.is_active === 1, 'badge-light-secondary': data.is_active === 0}">
                                    {{  data.is_active | contractStatusPipe: data?.period_renewal?.start_date }}
                                </div>
                              </td>
                            </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <!--/ Striped rows -->

            </div>
    }
    </div>
</div>
</ng-container>
